export default __webpack_public_path__ + "static/media/stk-employee-reg-visual-aid.cec2cd64.png";